<!-- Loader -->
<div class="text-center pb-8 animate-pulse">
    <div class="h-7 bg-blue-400 rounded w-full m-auto mb-1"></div>
    <div class="h-10 bg-blue-400 rounded w-full m-auto"></div>
</div>

{#each Array(3) as _ } 
    <div class="partner-row flex bg-white border border-transparent shadow-md py-1.5 px-2.5 items-center	mb-1.5 gap-x-2 justify-between">
            <div class="img-placeholder flex-1 max-h-14 h-full object-contain svelte-lazy-image"></div>
            <p class="score animate-pulse"></p>
            <button class="animate-pulse bg-red-500 flex items-center justify-center rounded-md text-white h-8 text-sm">
            </button>
    </div>
{/each}

<div class="flex items-center">
    <div class="flex-1">
        <div class="text-center animate-pulse ">
            <div class="h-7 bg-blue-400 rounded w-8/12 m-auto mb-2"></div>
        </div>
   </div>
</div>
<!-- Loader -->

<style lang="scss">
    .partner-row {
        .img-placeholder {
           height: 100px;
        }
        .score {
            min-width: 40px;
        }
        button {
            min-width: 100px;
            max-width: 120px;
            width: 100%;
        }
    }
</style>